<div class="container h-100 d-flex align-items-center justify-content-center">
  <div class="callback-container">
    <img class="h-100" src="assets/images/login-registration/login-callback.svg" draggable="false" />

    <h5 class="mb-0 text-center font-size-18">{{ 'login.callback.title' | translate }}</h5>
    <div class="font-size-14">{{ 'login.callback.description' | translate }}</div>
  </div>
</div>
